import { render, staticRenderFns } from "./DatatableCollections.vue?vue&type=template&id=024c12e8&scoped=true&"
import script from "./DatatableCollections.vue?vue&type=script&lang=js&"
export * from "./DatatableCollections.vue?vue&type=script&lang=js&"
import style0 from "./DatatableCollections.vue?vue&type=style&index=0&id=024c12e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024c12e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VDataTable,VIcon})
